// extracted by mini-css-extract-plugin
export default {"history":"ActivityReviewHistory_history__Quv0H","loading-wrapper":"ActivityReviewHistory_loading-wrapper__qMK+9"};